import { render, staticRenderFns } from "./CorpolatePlanSubmit.vue?vue&type=template&id=6097a1d4&"
import script from "./CorpolatePlanSubmit.vue?vue&type=script&lang=js&"
export * from "./CorpolatePlanSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports